import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import queryString from 'query-string';
import { Container } from 'reactstrap';

import {
  APPROVAL_ACTION_CONFIGURATION_EMPTY,
  GET_INVENTORY_VIEW_EMPTY,
  GET_BOOKINGS_LIST,
  GET_BOOKINGS_LIST_EMPTY,
  GET_CARD_SUMMARY,
  GET_DASHBOARD_CONFIGURATION,
  GET_INVENTORY_VIEW,
  PUBLISH_CONFIGURATION_EMPTY,
  GET_FILTERS_LIST,
  PUBLISH_APPROVAL_EMPTY,
  REVOKE_CONFIGURATION_EMPTY,
} from '../../../../../store/actions';
import { Loader } from '../../../../Common';
import BreadcrumbTrail from '../../../../Common/BreadcrumbTrail';
import { Constant } from '../../../../Helpers/constant';
import StatusFilter from './Components/Filter/StatusFilter';
import Summary from './Components/Summary';
import DataViews from './Components/Views';
import AirportTransferActionablesModals from './Components/Modals/AirportTransfer';
import Filter from './Components/Filter/Filter';

const ApprovalListing = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const {
    skip = 1,
    limit = Constant.TABLE_PAGE_SIZE,
    name = '',
    type = '',
    appliedName = '',
    appliedType = '',
    nextNavigation = '',
    page_name = '',
  } = queryString.parse(location.search);

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [currentPageNumber, setCurrentPageNumber] = useState(Number(skip) - 1);
  const [rowsPerPage, setRowsPerPage] = useState(Number(limit));

  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [assignedToMeFilter, setAssignedToMeFilter] = useState(false);
  const [secondaryFiltersList, setSecondaryFiltersList] = useState(null);

  const [loading, setLoading] = useState(false);
  const [currentActiveBookingAction, setCurrentActiveBookingAction] = useState(null);

  const [isMultiSelectable, setIsMultiSelectable] = useState(false);
  const [shouldHaveClearSelection, setShouldHaveClearSelection] = useState(false);
  const [currentSelectedBooking, setCurrentSelectedBooking] = useState(null);

  const [workflowStateFilters, setWorkflowStateFilters] = useState([]);
  const [workflowDisplayName, setWorkflowDisplayName] = useState(``);
  const [appliedNameOptional, setAppliedNameOptional] = useState(``);
  const [isFilterClear, setIsFilterClear] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { getDashboardConfiguration, getDashboardConfigurationLoading } = useSelector((state: any) => ({
    getDashboardConfiguration: state.GetDashboardConfiguration.data,
    getDashboardConfigurationLoading: state.GetDashboardConfiguration.loading,
  }));

  const { cardSummaryCount, cardSummaryCountLoading } = useSelector((state: any) => ({
    cardSummaryCount: state.GetCardSummary.data,
    cardSummaryCountLoading: state.GetCardSummary.loading,
  }));

  const { bookingsList, bookingsListLoading, bookingDetails, bookingDetailsLoading } = useSelector((state: any) => ({
    bookingsList: state?.GetBookingsList?.data,
    bookingsListLoading: state?.GetBookingsList?.loading,

    bookingDetails: state?.GetInventoryView?.data,
    bookingDetailsLoading: state?.GetInventoryView?.loading,
  }));

  const { approvalAction, publishConfiguration, publishApproval, revokeConfiguration } = useSelector((state: any) => ({
    approvalAction: state?.ApprovalActionConfiguration?.data,
    publishConfiguration: state?.PublishConfiguration?.data,
    publishApproval: state?.PublishApproval?.data,
    revokeConfiguration: state?.RevokeConfiguration?.data,
  }));

  useEffect(() => {
    if (approvalAction !== null || publishConfiguration !== null || publishApproval !== null || revokeConfiguration !== null) {
      if (isMultiSelectable) {
        setShouldHaveClearSelection(true);
        setTimeout(() => {
          setShouldHaveClearSelection(false);
        }, 1000);
      }

      dispatch({
        type: GET_BOOKINGS_LIST,
        payload: {
          urlParams: {
            page_size: limit,
            page_index: Number(skip),
            card_name: appliedName ? appliedName : name,
            ...currentlyAppliedFilters,
          },
          params: {
            card_type: appliedType ? appliedType : type,
          },
        },
      });

      dispatch({
        type: GET_INVENTORY_VIEW_EMPTY,
      });

      dispatch({
        type: GET_DASHBOARD_CONFIGURATION,
      });

      dispatch({
        type: APPROVAL_ACTION_CONFIGURATION_EMPTY,
      });

      dispatch({
        type: PUBLISH_CONFIGURATION_EMPTY,
      });

      dispatch({
        type: REVOKE_CONFIGURATION_EMPTY,
      });

      dispatch({
        type: PUBLISH_APPROVAL_EMPTY,
      });

      setCurrentSelectedBooking(null);
      setCurrentActiveBookingAction(null);
    }
  }, [approvalAction, publishConfiguration, publishApproval, revokeConfiguration]);

  useEffect(() => {
    if (name !== `` && type !== ``) {
      dispatch({
        type: GET_BOOKINGS_LIST,
        payload: {
          urlParams: {
            page_size: limit,
            page_index: Number(skip),
            card_name: appliedName ? appliedName : name,
            ...currentlyAppliedFilters,
          },
          params: {
            card_type: appliedType ? appliedType : type,
          },
        },
      });

      getCardSummaryCounts((appliedName ? appliedName : name) ?? '', 'GET_ALL', currentlyAppliedFilters);
    }
  }, [skip, limit, currentlyAppliedFilters, name, appliedName, workflowStateFilters, assignedToMeFilter]);

  // ********************* GET CARD SUMMARY COUNT *********************
  const getCardSummaryCounts = (name, flag, tempCurrentlyAppliedFilters) => {
    const tempStatusFilters = workflowStateFilters?.map(filter => ({ type: filter?.cardType, name: filter?.cardName }));

    let sendStatusFilters = [];
    if (cardSummaryCount === null && workflowStateFilters?.length > 0) {
      sendStatusFilters = tempStatusFilters;
    } else {
      sendStatusFilters = tempStatusFilters?.filter(statusFilter => statusFilter?.name === name);
    }

    if (flag === `GET_ALL`) {
      sendStatusFilters = tempStatusFilters;
    }

    if (workflowStateFilters?.length > 0) {
      dispatch({
        type: GET_CARD_SUMMARY,
        payload: {
          cards: sendStatusFilters ?? [],
          ...tempCurrentlyAppliedFilters,
          activeCard: appliedName || appliedNameOptional,
        },
      });
    }

    dispatch({
      type: GET_FILTERS_LIST,
      payload: {
        urlParams: {
          card_name: appliedName || name,
          card_type: appliedType || type,
        },
      },
    });
  };

  useEffect(() => {
    setCurrentPageNumber(Number(skip) - 1);
  }, [skip]);

  useEffect(() => {
    setRowsPerPage(Number(limit));
  }, [limit]);

  useEffect(() => {
    dispatch({
      type: GET_DASHBOARD_CONFIGURATION,
    });
  }, []);

  useEffect(() => {
    if (getDashboardConfiguration !== null) {
      let tempWorkflowStateFilters = [];
      let workflowDisplayName = ``;

      getDashboardConfiguration?.modules?.[nextNavigation?.toString()]?.sections?.forEach((section: any, index: number) => {
        section?.cards?.forEach((card: any, index: number) => {
          if (card?.name === name) {
            tempWorkflowStateFilters = card?.workflowStateFilters ?? [];
            if (appliedName) {
              card?.workflowStateFilters?.forEach(filter => {
                if (filter?.cardName === appliedName) {
                  workflowDisplayName = filter?.displayName;
                  setSecondaryFiltersList(filter?.secondaryFilters ?? null);
                }
              });
            } else {
              workflowDisplayName = card?.displayName;
            }
          }
        });
      });

      setWorkflowStateFilters(tempWorkflowStateFilters ?? []);

      if (tempWorkflowStateFilters?.length > 0 && !appliedName) {
        const tempActiveFilter = tempWorkflowStateFilters?.find(filter => filter?.isDefault === true)?.cardName || '';

        const tempAppliedName = tempWorkflowStateFilters?.find(filter => filter?.isDefault === true)?.cardName;
        const tempAppliedType = tempWorkflowStateFilters?.find(filter => filter?.isDefault === true)?.cardType;

        updateURLParams({ appliedName: tempAppliedName, appliedType: tempAppliedType });

        setAppliedNameOptional(appliedName || tempActiveFilter);
        setWorkflowDisplayName(workflowDisplayName);
        setSecondaryFiltersList(tempWorkflowStateFilters?.find(filter => filter?.isDefault === true)?.secondaryFilters ?? null);
      } else {
        setWorkflowDisplayName(workflowDisplayName);
      }
      setCurrentSelectedBooking(null);
    }
  }, [getDashboardConfiguration, location.search]);

  useEffect(() => {
    if (currentSelectedBooking?.length === 1) {
      dispatch({
        type: GET_INVENTORY_VIEW,
        payload: {
          urlParams: {
            id: currentSelectedBooking?.[0]?.id,
            card_name: appliedName || name,
          },
        },
      });
    }
  }, [currentSelectedBooking]);

  useEffect(() => {
    return () => {
      dispatch({
        type: GET_INVENTORY_VIEW_EMPTY,
      });
      dispatch({
        type: GET_BOOKINGS_LIST_EMPTY,
      });
    };
  }, []);

  const updateURLParams = newParams => {
    const currentParams = queryString.parse(location.search);

    const updatedParams = {
      ...currentParams,
      ...newParams,
    };
    const newUrl = queryString.stringify(updatedParams);
    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  const filterSubmitHandler = (filters = currentlyAppliedFilters) => {
    setCurrentlyAppliedFilters(filters);
    setCurrentActiveBookingAction(null);
    setCurrentSelectedBooking(null);
    dispatch({
      type: GET_INVENTORY_VIEW_EMPTY,
    });
    updateURLParams({ skip: 1, limit: limit });

    getCardSummaryCounts((appliedName ? appliedName : name) ?? '', 'GET_ALL', { ...filters });
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Pending Approvals`) {
      history.push(`/v2/pending-approvals`);
    } else if (title === `Saved Configuration`) {
      history.push(`/v2/saved-configuration`);
    }
  };

  const updateFilter = (startDate, endDate) => {
    updateURLParams({ startDate, endDate });
  };

  useEffect(() => {
    if (bookingsListLoading || bookingDetailsLoading || getDashboardConfigurationLoading || cardSummaryCountLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [bookingsListLoading, bookingDetailsLoading, getDashboardConfigurationLoading, cardSummaryCountLoading]);

  return (
    <div className="page-content">
      {loading && <Loader zIndex={true} />}

      <AirportTransferActionablesModals
        currentSelectedBooking={currentSelectedBooking}
        currentActiveBookingAction={currentActiveBookingAction}
        setCurrentActiveBookingAction={setCurrentActiveBookingAction}
        isMultiSelectable={isMultiSelectable}
        bookingDetails={bookingDetails}
        cardName={appliedName}
      />

      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`${page_name ? page_name?.toString() : workflowDisplayName}`}
              navigationby={breadcrumNavigationHandler}
              navigation={
                page_name
                  ? ['Quick Links', page_name?.toString(), 'Configuration List']
                  : ['Quick Links', getDashboardConfiguration?.modules?.[nextNavigation?.toString()]?.name, `${workflowDisplayName || ''}`]
              }
            />
          </div>

          <Filter filterHandler={filterSubmitHandler} isFilterClear={isFilterClear} />
        </div>

        <>
          {workflowStateFilters.length > 0 && (
            <StatusFilter
              statusFilters={workflowStateFilters}
              appliedStatusFilter={appliedName || appliedNameOptional}
              updateURLParams={updateURLParams}
              setCurrentSelectedBooking={setCurrentSelectedBooking}
              setCurrentActiveBookingAction={setCurrentActiveBookingAction}
              setWorkflowDisplayName={setWorkflowDisplayName}
              cardSummaryCount={cardSummaryCount}
              setShouldHaveClearSelection={setShouldHaveClearSelection}
              setSecondaryFiltersList={setSecondaryFiltersList}
              setAssignedToMeFilter={setAssignedToMeFilter}
              setIsFilterClear={setIsFilterClear}
            />
          )}

          <DataViews
            data={bookingsList}
            updateURLParams={updateURLParams}
            skip={currentPageNumber}
            limit={rowsPerPage}
            selectedBooking={currentSelectedBooking}
            setCurrentSelectedBooking={setCurrentSelectedBooking}
            setCurrentActiveBookingAction={setCurrentActiveBookingAction}
            titleText={page_name ? 'Airport Transfer' : workflowDisplayName}
            appliedName={appliedName?.toString()}
            isMultiSelectable={isMultiSelectable}
            setIsMultiSelectable={setIsMultiSelectable}
            shouldHaveClearSelection={shouldHaveClearSelection}
            setShouldHaveClearSelection={setShouldHaveClearSelection}
            filterSubmitHandler={filterSubmitHandler}
            currentlyAppliedFilters={currentlyAppliedFilters}
            assignedToMeFilter={assignedToMeFilter}
            setAssignedToMeFilter={setAssignedToMeFilter}
            secondaryFiltersList={secondaryFiltersList}
          />

          {currentSelectedBooking?.length === 1 && bookingDetails && (
            <Summary
              details={bookingDetails}
              currentSelectedBooking={currentSelectedBooking?.[0]}
              setCurrentSelectedBooking={setCurrentSelectedBooking}
              setCurrentActiveBookingAction={setCurrentActiveBookingAction}
              title={workflowDisplayName}
            />
          )}
        </>
      </Container>
    </div>
  );
};

export default ApprovalListing;
